import React, { useCallback } from "react";
import "./PostContentShare.scss";
import { FaPlay } from "react-icons/fa";

const PostContentShare = ({ content, type }) => {
    const onContentClick = useCallback(() => {
        const parsedUrl = new URL(window.location.href);
        let content_type = ""
        if (type === "video" || type === "episode") {
            content_type = "videos"
        } else if (type === "show") {
            content_type = "show-details"
        } else {
            content_type = "event"
        }
        const redirectedUrl = `${parsedUrl.origin}/${content_type}/${content?.vanity_url}`;

        window.open(redirectedUrl, "_blank");
    }, [content, type]);
    return (
        <div className="post-content-share" onClick={onContentClick}>
            <div className="content-container">
                <div className="thumbnail">
                    <div className="image-container">
                        <img src={content?.thumbnail} alt="thumbnail" />
                        <div className="play-overlay">
                            <div className="play-button">
                                <FaPlay />
                            </div>
                            {/* <div className="duration">{content?.duration || "32:00"}</div> */}
                        </div>
                    </div>
                </div>
                <div className="content-details">
                    <div className="title">{content?.title}</div>
                    <div className="description">
                        {content?.description}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostContentShare;